export default {
  pt: {
    'charts.donut.empty': 'Nada por aqui ainda.',
  },
  en: {
    'charts.donut.empty': 'Nothing here yet.',
  },
  es: {
    'charts.donut.empty': 'Nada por aquí todavía.',
  },
}
